import { Injectable } from '@angular/core';

/**
 * Helper service for branding-related utility functions.
 * Provides common functions for handling Base64 data URLs and favicon manipulation.
 */
@Injectable({
  providedIn: 'root',
})
export class BrandingSettingsHelperService {
  /**
   * Creates a data URL from Base64 string and content type.
   * If the Base64 string already contains the data URL prefix, it returns as-is.
   *
   * @param base64 - The Base64-encoded string
   * @param contentType - The MIME type (e.g., 'image/png', 'image/x-icon')
   * @returns Complete data URL string
   */
  createDataUrl(base64: string, contentType: string): string {
    if (base64.startsWith('data:')) {
      return base64;
    }
    return `data:${contentType};base64,${base64}`;
  }

  /**
   * Updates the browser's favicon dynamically.
   * Creates a new link element if one doesn't exist, or updates the existing one.
   *
   * @param dataUrl - The data URL of the favicon image
   */
  updateBrowserFavicon(dataUrl: string): void {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'shortcut icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    link.type = 'image/x-icon';
    link.href = dataUrl;
  }
}
